var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"emoji-input"},_vm._l((_vm.emojiSet),function(item,index){return _c('div',{key:index,on:{"click":function($event){return _vm.onClick(item)}}},[_vm._v(_vm._s(item))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }